import { Link } from "react-router-dom";
import { PlusCircle, ScanLine, ClipboardList, Archive, Wallet, ArrowUpRight } from "lucide-react";
import { format } from "date-fns";
import { it } from "date-fns/locale";

const greeting = () => {
  const h = new Date().getHours();
  return h < 13 ? "Buongiorno" : h < 18 ? "Buon pomeriggio" : "Buonasera";
};

const ACTIONS = [
  { to: "/home", label: "Registra ordine", icon: PlusCircle, id: "register-order" },
  { to: "/scanner", label: "Scanner", icon: ScanLine, id: "scanner" },
  { to: "/picking-list", label: "Picking list", icon: ClipboardList, id: "picking" },
  { to: "/sales", label: "Archivio vendite", icon: Archive, id: "sales-archive" },
];

export const DashHero = ({ data }) => {
  const diff = data.orders_today - data.orders_yesterday;
  return (
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 md:gap-6">
      <section className="dash-rise lg:col-span-8 relative overflow-hidden rounded-2xl border border-[#C9A227]/20 bg-[#12141F] p-6 md:p-8" data-testid="hero-section">
        <div className="absolute -right-24 -top-24 w-80 h-80 rounded-full bg-[#C9A227]/10 blur-3xl pointer-events-none" />
        <div className="absolute inset-0 opacity-[0.07] pointer-events-none" style={{ backgroundImage: "linear-gradient(#E5C158 1px, transparent 1px), linear-gradient(90deg, #E5C158 1px, transparent 1px)", backgroundSize: "40px 40px" }} />
        <div className="relative">
          <p className="text-xs font-mono uppercase tracking-[0.25em] text-[#E5C158]">{format(new Date(), "EEEE d MMMM yyyy", { locale: it })}</p>
          <h1 className="mt-2 text-3xl sm:text-4xl lg:text-5xl font-serif text-white">{greeting()}, Team</h1>
          <div className="mt-6 flex items-end gap-4 flex-wrap">
            <span className="font-mono font-extrabold text-6xl md:text-7xl leading-none text-transparent bg-clip-text bg-gradient-to-r from-amber-200 via-[#E5C158] to-amber-500" data-testid="hero-orders-today">{data.orders_today}</span>
            <div className="pb-2">
              <p className="text-zinc-300 text-sm">{data.orders_today === 1 ? "ordine oggi" : "ordini oggi"}</p>
              <p className={`text-xs font-mono ${diff >= 0 ? "text-emerald-400" : "text-rose-400"}`} data-testid="hero-orders-diff">
                {diff >= 0 ? "+" : ""}{diff} rispetto a ieri ({data.orders_yesterday})
              </p>
            </div>
          </div>
          <div className="mt-6 grid grid-cols-2 sm:grid-cols-4 gap-2" data-testid="quick-actions-bar">
            {ACTIONS.map(({ to, label, icon: Icon, id }) => (
              <Link key={id} to={to} data-testid={`quick-action-${id}`}
                className="group flex items-center gap-2 rounded-xl border border-white/10 bg-white/[0.03] px-3 py-3 text-sm text-zinc-200 hover:border-[#E5C158]/60 hover:bg-[#C9A227]/10 transition-colors">
                <Icon className="w-4 h-4 text-[#E5C158] group-hover:scale-110 transition-transform" />{label}
              </Link>
            ))}
          </div>
        </div>
      </section>
      <Link to="/analytics-avanzate" data-testid="analytics-cta"
        className="dash-rise lg:col-span-4 group relative overflow-hidden rounded-2xl p-6 md:p-8 flex flex-col justify-between bg-gradient-to-br from-[#E5C158] via-[#C9A227] to-[#8a6a12] text-[#0A0B0F]">
        <Wallet className="w-10 h-10" />
        <div className="mt-8">
          <p className="text-xs font-mono uppercase tracking-[0.25em] opacity-70">Soldi</p>
          <p className="text-2xl md:text-3xl font-serif font-bold leading-tight">Analytics &amp; Incassi</p>
          <p className="text-sm mt-1 opacity-80">Fatturato, guadagni netti, canali e previsioni</p>
        </div>
        <ArrowUpRight className="absolute top-6 right-6 w-6 h-6 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
      </Link>
    </div>
  );
};
